import { all, takeEvery, put, fork, call } from 'redux-saga/effects';
import {
    GET_PERMISSIONS, 
} from './actionTypes';

import {
	setMemberToken, 
} from "../member/actions";

import {
	 setPermissions
} from "./actions";

import PermissionService from '../../services/Permissions/PermissionService';


export function* getPermissions() {
  yield takeEvery(GET_PERMISSIONS, function* ({ payload: { token, history } }) {
    try {
      const response = yield call(
        PermissionService.getMemberPermissions,
        token
      );
      const permissionsList = response.data;
      yield put(setMemberToken(token));
      yield put(setPermissions(permissionsList));

      localStorage.setItem("permissions", JSON.stringify(permissionsList));

	  history.push("/");

    } catch (err) {}
  });
}


export default function* rootSaga() {
    yield all([
          fork(getPermissions),
    ]);
  }
  